// Budget settings constants
export const BUDGET_DEFAULTS = {
	MONTHLY_BUDGET: 10_000,
} as const;

export const BUDGET_LIMITS = {
	MIN: 0,
	MAX: 1000000,
	STEP: 100,
} as const;
